export default function LinkExpired() {
  return (
    <div className="card card--error">
      <div className="card-icon card-icon--error">&#9888;</div>
      <h2>Link non valido o scaduto</h2>
      <p>
        Spiacenti, il link per il recupero della password non è più attivo
        per motivi di sicurezza (scadenza dopo 48h o token non valido).
      </p>
      <p style={{ marginTop: '1rem' }}>
        Ti preghiamo di fare riferimento all'ultima comunicazione ricevuta
        o contattare l'assistenza.
      </p>
      <a href="mailto:ESGproducts@iongroup.com" className="btn" style={{ marginTop: '20px', display: 'inline-block', width: 'auto', padding: '10px 20px' }}>
        Contatta Assistenza
      </a>
    </div>
  );
}
